import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../hooks/redux';
import Spinner from '../spinner';
import UserSidebar from '../userSidebar/userSidebar';
import './userLayout.scss';

const UserLayout: React.FC = () => {
  const location = useLocation();
  const { authChecked, isAuthenticated, user } = useAppSelector((state) => state.user);
  const isAdminRoute = location.pathname.startsWith('/UserPage/admin');

  if (!authChecked) {
    return <Spinner />;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className={`user-wrapper${isAdminRoute ? ' user-wrapper--admin-route' : ''}`}>
      <UserSidebar />
      <div className="user-container">
        <Outlet />
      </div>
    </div>
  );
};

export default UserLayout;
